import React, { Component } from 'react';
import { Field } from 'redux-form';
import { ReferenceInput, SelectInput, TextInput } from 'react-admin';

import CodeMirrorViewer from '../Helpers/CodeMirrorViewer';
import FetchData from '../../../Framework/Fetch';

type Props = {
  attribute_name: string,
  index: number,
  prefix: string,
  record: any
};

type StateProps = {
  jscode: string,
  parameters: string[]
};

class JsFunction extends Component<Props, StateProps> {
  state = { jscode: null, parameters: [] };

  componentDidMount() {
    if (
      this.props.record &&
      this.props.record.ad_units &&
      this.props.record.ad_units[this.props.index] &&
      this.props.record.ad_units[this.props.index][this.props.attribute_name].jsfunction
    ) {
      this.updateJsFunction(this.props.record.ad_units[this.props.index][this.props.attribute_name].jsfunction);
    } else {
      this.setState({ parameters: [] });
    }
  }

  handleChange = (e, index, value) => {
    this.updateJsFunction(index)
  }

  updateJsFunction = (index) => {
    if (index) {
      FetchData('/helpers/js_functions/' + index, {})
        .then((json) => {
          this.setState({ jscode: json.jscode });

          if (json.parameters) {
            let parameters = json.parameters.map((parameter, index) => {
              return { description: parameter.description, key: index, id: index, name: parameter.name }
            });
            this.setState({ parameters: parameters });
          } else {
            this.setState({ parameters: [] });
          }
        });
    } else {
      this.setState({ jscode: null, parameters: [] });
    }
  }

  render() {
    return (
      <div style={{ paddingTop: 20 }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Field
              allowEmpty
              component={ReferenceInput}
              label="JS Functions"
              name={`${this.props.prefix}.jsfunction`}
              onChange={(event, key, value) => this.handleChange(event, key, value)}
              record={this.props.record}
              reference="helpers/js_functions"
              resource="placements"
              sort={{ field: 'name', order: 'ASC' }}
              source={`${this.props.prefix}.jsfunction`}
            >
              <Field
                component={SelectInput}
                label="JS Functions"
                name={`${this.props.prefix}.jsfunction`}
                source={`${this.props.prefix}.jsfunction`} />
            </Field><br /><br />

            {this.state.parameters && this.state.parameters.map((item, index) => {
              return (
                <div key={index} style={{ width: '90%', paddingBottom: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>{item.name}</span><br />
                  <span style={{ color: 'gray' }}>{item.description}</span><br />
                  <Field
                    component={TextInput}
                    label=""
                    name={`${this.props.prefix}.parameters.${item.name}`}
                    source={`${this.props.prefix}.parameters.${item.name}`} />
                </div>
              )
            })}
          </div>
          <div style={{ flex: 1, maxWidth: 600 }}>
            <CodeMirrorViewer
              jscode={this.state.jscode}
              prefix={this.props.prefix}
              index={this.props.index}
              attribute_name={this.props.attribute_name} /><br /><br />
          </div>
        </div>
      </div>
    )
  }
};

export default JsFunction;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/JsFunction.tsx